var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, startTransition, useCallback, useMemo, useState } from 'react';
import awaitInteractionResponse from 'await-interaction-response';
export const CustomPaginationContext = createContext({});
export const CustomPaginationProvider = (props) => {
    const { setLength, length, children, setPageNo, pageNo } = props;
    // CLS Fix: Track loading state and expected product count for skeleton placeholders
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [pendingProductCount, setPendingProductCount] = useState(0);
    const handleLoadMore = useCallback((remainingProducts) => __awaiter(void 0, void 0, void 0, function* () {
        // CLS Fix: Set loading state before fetching more products
        setIsLoadingMore(true);
        setPendingProductCount(remainingProducts !== null && remainingProducts !== void 0 ? remainingProducts : 0);
        yield awaitInteractionResponse();
        startTransition(() => {
            if (setPageNo && typeof pageNo === 'number') {
                setPageNo(pageNo + 1);
            }
            setLength(length + 12);
        });
    }), [length, setLength, setPageNo, pageNo]);
    const handleLoadAll = useCallback((totalCount) => __awaiter(void 0, void 0, void 0, function* () {
        // CLS Fix: Set loading state and calculate how many more products to show
        setIsLoadingMore(true);
        const remainingProducts = (totalCount !== null && totalCount !== void 0 ? totalCount : 0) - length;
        setPendingProductCount(Math.max(remainingProducts, 0));
        yield awaitInteractionResponse();
        startTransition(() => {
            setLength(totalCount || 1000);
        });
    }), [setLength, length]);
    // CLS Fix: Function to clear loading state (called when products are rendered)
    const clearLoadingState = useCallback(() => {
        setIsLoadingMore(false);
        setPendingProductCount(0);
    }, []);
    const paginationValue = useMemo(() => ({
        loadAll: handleLoadAll,
        loadMore: handleLoadMore,
        isLoadingMore,
        pendingProductCount,
        clearLoadingState,
    }), [handleLoadAll, handleLoadMore, isLoadingMore, pendingProductCount, clearLoadingState]);
    return _jsx(CustomPaginationContext.Provider, { value: paginationValue, children: children });
};
